import './style/normalize.css';
import './style/global.css';
import './style/systems.css';
import Forms from './components/forms';

export default Forms;
